import {
  GETCUSTOMERIDANDNAMELIST_SUCCESS,
  GETCUSTOMERIDANDNAMELIST_FAILED,
  RESET_GETCUSTOMERIDANDNAMELIST,
  LOADING_GETCUSTOMERIDANDNAMELIST,
  NETWORK_ERROR_GETCUSTOMERIDANDNAMELIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetCustomerIdAndNameList = () => {
  return { type: RESET_GETCUSTOMERIDANDNAMELIST };
};

const getCustomerIdAndNameList =
  (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETCUSTOMERIDANDNAMELIST });
    await partnerServices
      .post("getCustomerIdAndNameList", userData, { headers: { AuthToken: authTokenIs } })
      .then((res) => {
        switch (res.data.status) {
          case "Success":
            dispatch(getCustomerIdAndNameListsuccess(res.data));
            break;
          default:
            dispatch(getCustomerIdAndNameListFailed(res.data));
            break;
        }
      })
      .catch((err) => {
        dispatch({
          type: NETWORK_ERROR_GETCUSTOMERIDANDNAMELIST,
          payload: err,
        });
      });
  };
function getCustomerIdAndNameListsuccess(data) {
  return {
    type: GETCUSTOMERIDANDNAMELIST_SUCCESS,
    payload: data,
  };
}
function getCustomerIdAndNameListFailed(data) {
  return {
    type: GETCUSTOMERIDANDNAMELIST_FAILED,
    payload: data,
  };
}

export { resetGetCustomerIdAndNameList, getCustomerIdAndNameList };
